/**
 * HistoryScreen — Histórico de execuções (Bloco 6).
 *
 * Lista as execuções anteriores do tenant (GET /history, dados reais de
 * app.executions). "Abrir" roteia: failed→failure, resto→output.
 */
import { C } from '@/theme/palette';
import { useNavigationContext } from '@/navigation';
import { useHistory } from '@/api/history';

// Paleta: segue o tema global (aliases bg/surface/border/text/dim/muted… em theme/palette.js).
const STC = { completed: C.ok, running: C.accent, failed: C.bad, pending: C.warn };

export function HistoryScreen() {
  const { navigate } = useNavigationContext();
  const { data, isLoading } = useHistory();
  const items = data?.items ?? [];

  const open = (it) => {
    const q = `?execution=${it.executionId}`;
    navigate(String(it.status).toLowerCase() === 'failed' ? `/execution/failure${q}` : `/execution/output${q}`);
  };

  return (
    <div className="sp-page" style={{ color: C.text }}>
      <h2 style={{ margin: 0, fontSize: 22, letterSpacing: '-0.02em' }}>Histórico de execuções</h2>
      <p style={{ color: C.dim, marginTop: 10, fontSize: 13.5 }}>
        Execuções anteriores do tenant. Clique em <strong style={{ color: C.text }}>Abrir</strong> para ver o resultado.
      </p>
      {isLoading && <div style={{ marginTop: 20, color: C.dim }}>Carregando…</div>}
      {!isLoading && items.length === 0 && (
        <div style={{ marginTop: 24, padding: 28, border: `1px dashed ${C.border}`, borderRadius: 12,
          color: C.dim, textAlign: 'center' }}>Nenhuma execução ainda.</div>
      )}
      {items.length > 0 && (
        <div style={{ marginTop: 18, border: `1px solid ${C.border}`, borderRadius: 12, overflow: 'hidden' }}>
          {items.map((it, i) => (
            <div key={it.executionId} style={{ display: 'grid', gridTemplateColumns: '1fr 130px 170px 90px',
              gap: 12, alignItems: 'center', padding: '11px 16px',
              borderTop: i ? `1px solid ${C.border}` : 'none' }}>
              <span style={{ fontSize: 13.5 }}>{it.projectName || '(sem nome)'}</span>
              <span style={{ fontFamily: 'monospace', fontSize: 11.5, color: STC[String(it.status).toLowerCase()] || C.muted }}>
                {it.status}
              </span>
              <span style={{ fontFamily: 'monospace', fontSize: 11, color: C.muted }}>
                {it.startedAt ? new Date(it.startedAt).toLocaleString('pt-BR') : ''}
              </span>
              <button onClick={() => open(it)} style={{ background: 'transparent', color: C.accent,
                border: `1px solid ${C.accent}`, borderRadius: 7, padding: '5px 12px', fontSize: 12,
                cursor: 'pointer' }}>Abrir</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
